/* eslint-disable indent */
<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE VENDEDORES" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" :btnHide="true" titleReport="Relátorio de Usuários">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                           
                            <div class="md-layout-item md-size-30 md-xsmall-size-100 ml-auto">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <label for="pages">Pesquisar</label>
                                    <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 8%" md-sort-by='id'>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="NOME" style="width: 30%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="USUÁRIO" style="width: 20%" md-sort-by="usuario">{{ item.usuario }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 25%" md-sort-by="empresa">{{ item.empresa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="SITUAÇÃO" style="width: 10%" md-sort-by="situacao">{{ item.situacao }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 7%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>                              
                                    <md-menu-item v-if="item.situacao_id == 2 && permissoes.usuarioInactivate" @click="inativar(item.id, item.nome, 'ATIVAR?')">
                                        ATIVAR<md-icon class="text-success">thumb_up_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="item.situacao_id == 1 && permissoes.usuarioActivate" @click="inativar(item.id, item.nome, 'INATIVAR?')">
                                        INATIVAR<md-icon class="text-danger">thumb_down_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.usuarioDelete" @click="excluir(item.id, item.nome)">
                                        EXCLUIR<md-icon class="text-danger">delete</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'ReadUsuario',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    mixins: [TableSearch, Notify, preLoader],

    data() {
        return {
            permissoes: this.$store.state.usuario.permissao,
            rotaInactivate: 'usuarios/inativar/',
            rotaActivate: 'usuarios/ativar/',
            titleInactivate: 'INATIVAR?',
            rotaDeletar: 'usuarios/',
            rotaExcluir: 'usuarios/excluir/',
            columnsPDF: [15, 85, 50, 30],
            headRowsPDF: ['ID', 'NOME', 'USUÁRIO', 'SITUAÇÃO'],
            fildsTXT: ['id', 'nome', 'usuario', 'situacao'],
            bodyRowsPDF: ['id', 'nome', 'usuario', 'situacao'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "NOME",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "USUÁRIO",
                    field: "usuario",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "SITUAÇÃO",
                    field: "situacao",
                    dataFormat: this.upperCaseFormat
                }
            ],
            search: null,
            tableData: [],
            searchedData: []
        };
    },

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'usuarios/vendedores')
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.usuario]).includes(this.toLower(term)))
            }
            return items
        },


        inativar(id, nome, tipo) {
            this.titleInactivate = tipo
            this.handleInactivate(id, nome)
        },

        excluir(id, nome) {
            this.handleDelete(id, nome)
        }

    },

};
</script>

<style>
.menuTable {
    margin-right: 50% !important;
}

.menuTableItem {
    font-weight: bold;
}
</style>
